import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreatePayByLinkLiability } from '../models/create-pay-by-link-liability.model';
import { environment } from '../../environments/environment';
import { LiabilityDataModel } from '../models/liability-data.model';
import { Token } from '../models/token.model';
import { ImojeActiveBankModel } from '../models/imoje-active-bank.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PaymentApiService {
  private readonly apiPath = `${environment.apiPath}/payments`;

  constructor(private http: HttpClient) {}

  postPayByLinkLiabilities(body: CreatePayByLinkLiability): Observable<Token> {
    const parsedBody: CreatePayByLinkLiability = {
      returnUrl: '',
      issueDate: '',
      providerCode: body.providerCode,
      externalId: body.externalId,
      invoiceNumber: body.invoiceNumber,
      clientName: body.clientName,
      clientSurname: body.clientSurname,
      email: body.email,
      amount: Number(body.amount),
      account: body.account,
      paymentDue: body.paymentDue,
      signature: body.signature
    };

    return this.http.post<Token>(`${environment.legacyApiPath}/pay-by-link-liabilities`, parsedBody);
  }

  getPayByLinkLiabilities(token: string): Observable<LiabilityDataModel> {
    return this.http.get<LiabilityDataModel>(`${this.apiPath}/${token}`);
  }

  getActiveBanks(token: string, isBalance: boolean): Observable<ImojeActiveBankModel[]> {
    return this.http
      .get<ImojeActiveBankModel[]>(`${this.apiPath}/${token}/active-banks`, {
        params: { balance: isBalance.toString() }
      })
      .pipe(map(banks => (!environment.offlineBanksForTest ? banks : this.setOfflineBanksForTests(banks))));
  }

  private setOfflineBanksForTests(banks: ImojeActiveBankModel[]) {
    return banks.map(bank => ({
      ...bank,
      isOnline: bank.isOnline && !environment.offlineBanksForTest.includes(bank.code)
    }));
  }
}
